// Sentry initialization for error tracking
(function() {
  // Load Sentry from CDN
  const script = document.createElement('script');
  script.src = 'https://browser.sentry-cdn.com/7.119.0/bundle.min.js';
  script.integrity = 'sha384-N/+t7zuoySxu9rbUlySpn5qv9w/rBT0D7HE35N2dXNy/1W68iV8i6hc13TPJnKOB';
  script.crossOrigin = 'anonymous';
  
  script.onload = function() {
    if (window.Sentry) {
      Sentry.init({
        dsn: "https://ded8b11bb92d69b184b8ce7409af0108@o4510189822803968.ingest.us.sentry.io/4510189827325952",
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        // Set sample rate for performance monitoring
        tracesSampleRate: 1.0,
        // Set the environment
        environment: window.location.hostname.includes('myshopify.com') ? 'development' : 'production',
        // Add integrations for better error tracking
        integrations: [
          new Sentry.BrowserTracing(),
          new Sentry.Replay({
            maskAllText: false,
            blockAllMedia: false,
          }),
        ],
        // Session Replay sample rate
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
      });

      console.log('Sentry initialized successfully');
    }
  };
  
  script.onerror = function() {
    console.error('Failed to load Sentry');
  };
  
  document.head.appendChild(script);
})();
